import * as React from 'react';
import styled from '../theme'
import RegistrationForm from '../components/RegistrationForm';
import { IRegistrationSubmission } from '../App'
import LogoComponent from '../components/LogoComponent';
import { isConcierge } from '../lib/config'
import { PreArrivalPage } from './PreArrivalPage'

export interface IRegistrationProps {
    content: any
    touristContent?: any
    locale: string
    logo: any
    language: string
    changeLocale(e: any): void
    submitRegistration(payload: IRegistrationSubmission): void
}

class RegistrationPage extends React.Component<IRegistrationProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const isFromConcierge = isConcierge || window.location.hostname.indexOf('concierge') !== -1
        return (
            isFromConcierge ?
            <MainWrapper>
                <LogoComponent logo={this.props.logo} />
                <Wrapper>
                    <RegistrationForm
                        changeLocale={this.props.changeLocale}
                        content={this.props.content}
                        locale={this.props.locale}
                        language={this.props.language}
                        submitRegistration={this.props.submitRegistration}
                        source={'digital_tourist_passport'}
                    />
                </Wrapper>
            </MainWrapper> :
            <PreArrivalPage {...this.props}/>
        )
    }

}

export default RegistrationPage

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 90px;
    width: 100%;
    box-sizing: border-box;
`
const MainWrapper = styled.div`
    background: -webkit-linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
    background: linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
    color: ${(props: any) => props.theme.colors.bodyHighlght};
    width: 100%;
    min-height: 100%;
    padding: 40px;
    box-sizing: border-box;
`



// WEBPACK FOOTER //
// ./src/pages/RegistrationPage.tsx